export default __webpack_public_path__ + "static/pubertad-end-game-mb-e07fbe113df2b4681c525008fa5af226.png";